<div class="container-fluid col-11 px-4">
  <p-card>
    <form #cleanupListForm="ngForm" id="cleanupListForm" class="d-flex justify-content-center">
      <div class="row w-80">
        <div class="col-12 flex justify-content-end">
          <p-button severity="primary" type="button" icon="pi pi-plus" [disabled]="editing" (click)="addCleanupByCustomer()"> </p-button>
        </div>
        <div class="table-container">
          <ng-container *ngIf="showTable">
            <p-table #rm id="cleanupListTable"
                 [value]="clonedCustomerCleanupConfigurations" dataKey="id" editMode="row"
                 [multiSortMeta]="[orderByKey]" sortMode="multiple"
                 class="table invisible-division-line striped-table">
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="name"            style="width:45%" (click)="updateSortField('name', 'orderName')"                       translate> Common.Customer                              <p-sortIcon field="name">            </p-sortIcon> </th>
                  <th pSortableColumn="retentionMonths" style="width:35%" (click)="updateSortField('retentionMonths', 'orderRetentionMonths')" translate> Administration.Cleanup.Form.Retention Months <p-sortIcon field="retentionMonths"> </p-sortIcon> </th>
                  <th> </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-cleanupByCustomer let-editing="editing" let-ri="rowIndex">
                <tr [pEditableRow]="cleanupByCustomer" class="row-data">
                  <td>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-select
                          name="customer"
                          #airline="ngModel"
                          inputId="customer"
                          optionLabel="name"
                          optionValue="customerId"
                          appendTo="body"
                          [options]="customersList"
                          [(ngModel)]="cleanupByCustomer.customerId"
                          [placeholder]="customerPlaceholderSelected | translate"
                          [filter]="true"
                          required
                        >
                        </p-select>
                      </ng-template>
                      <ng-template pTemplate="output"> {{ cleanupByCustomer.name }} </ng-template>
                    </p-cellEditor>
                  </td>

                  <td>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-inputNumber
                            #retentionMonths="ngModel"
                            name="retentionMonths"
                            mode="decimal"
                            [(ngModel)]="cleanupByCustomer.retentionMonths"
                            [showButtons]="true"
                            [min]="1"
                            [max]="99"
                            required>
                        </p-inputNumber>
                      </ng-template>
                      <ng-template pTemplate="output"> {{ cleanupByCustomer.retentionMonths }} </ng-template>
                    </p-cellEditor>
                  </td>

                  <td>
                    <div class="flex align-items-center justify-content-center gap-2">
                      @if (!editing){
                        <p-button [link]="true" id="{{ 'edit-' + (ri + 1) }}" type="button" pInitEditableRow icon="pi pi-pencil"
                          (click)="onEditCleanup($event, cleanupByCustomer)"
                          [disabled]="onEdition">
                        </p-button>
                        <p-button link="true" severity="danger" type="button" icon="pi pi-trash"
                          (click)="onDeleteCleanUp(cleanupByCustomer)"
                          [disabled]="onEdition">
                        </p-button>
                      } @else {
                        <p-button [link]="true" type="button" pSaveEditableRow icon="pi pi-check"
                          (click)="onSaveCleanup(cleanupByCustomer)"
                          [disabled]="cleanupByCustomer.customerId == customerIdByDefault || !cleanupByCustomer.retentionMonths">
                        </p-button>
                        <p-button [link]="true" type="button" pCancelEditableRow icon="pi pi-times"
                          (click)="onCancelCleanup()">
                        </p-button>
                      }
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="9" translate> Table Commons.Not Found </td>
                </tr>
              </ng-template>
            </p-table>
          </ng-container>
        </div>
      </div>
    </form>
  </p-card>
</div>
